import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import React, { Component } from "react";
import { getStoreList } from "./service";


const google = window.google
const mapStyles = {
    width: '100%',
    height: '100%',
    // position: 'relative',
    // overflow: 'hidden',
    padding: '30px'
};
class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            markers: [],
            // empCd: this.props.location.saleDetail.empCd,
            // empCd: '900001',
            // date: moment().format(dateFormat),
            dateString: null,
            // shopSearch: this.props.data,
            // data: this.props.data,
            shopSearch: [],
            data: [],
            myMap: null,
            showingInfoWindow: false,
            activeMarker: {},
            activeMarkerCard: false,
        };
    }

    componentDidMount() {

        this.getData();
    }

    getData = () => {
        getStoreList().then(res => {
            if (res && res.status === 200) {
                this.setState({
                    data: res.data.info,
                    shopSearch: res.data.info,
                })
            }
        })
    }
    showMarkers = () => {
        return this.state.shopSearch.map((store, index) => {
            // console.log("store", store)

            return <Marker key={index} id={index} position={{
                lat: store.latitude,
                lng: store.longitude
            }}
                valuename={store.store_name}
                valuephone={store.phone1}
                valueaddress={store.full_address}
                valuefn={store.firstName_th}
                valueln={store.lastName_th}
                valuestore={store}
                onClick={this.onMarkerClick}
            />

        })
    }

    onMarkerClick = (props, marker) => {
        // console.log("marker", marker)
        this.setState({
            activeMarker: marker,
            activeMarkerCard: true,
            showingInfoWindow: true
        });
    };
    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            activeMarkerCard: false,
            showingInfoWindow: false
        });
    }

    render() {
        // console.log('this p', this.props)
        // if (!this.props.google) {
        //     return <div>Loading...</div>;
        // }
        return (
            <Map
                google={google}
                zoom={10}
                style={mapStyles}
                initialCenter={{ lat: 13.7278956, lng: 100.5241235 }}
                disableDefaultUI
                zoomControl
            >
                {this.state.data.length > 0 && this.showMarkers()}

                <InfoWindow
                    marker={this.state.activeMarker}
                    onClose={this.onInfoWindowClose}
                    visible={this.state.showingInfoWindow}>

                    {this.state.activeMarker &&
                        <div>
                            <h1>{this.state.activeMarker.valuename}</h1>
                            <p>{this.state.activeMarker.valuephone}</p>
                            <p>{this.state.activeMarker.valueaddress}</p>
                            <p>{this.state.activeMarker.valuefn}{' '}{this.state.activeMarker.valueln}</p>
                        </div>
                    }

                </InfoWindow>
            </Map>
            // <Map style={{}} google={this.props.google} zoom={14}>
            //     <Marker
            //         onClick={this.onMarkerClick}
            //         icon={{
            //             url: "/img/icon.svg",
            //             anchor: new google.maps.Point(32, 32),
            //             scaledSize: new google.maps.Size(64, 64)
            //         }}
            //         name={"Current location"}
            //     />
            //     <InfoWindow
            //         marker={this.state.activeMarker}
            //         visible={this.state.showingInfoWindow}
            //     >
            //         <div>
            //             <h1>{this.state.activeMarker.valuename}</h1>
            //         </div>
            //     </InfoWindow>
            // </Map>
        );
    }
}

// MapContainer = GoogleApiWrapper({
//     apiKey: "AIzaSyCr8dYXfkQUzH1qYMoBgqjtWTqLgbydr_U"
// })(MapContainer);
// export default GoogleApiWrapper({
//     apiKey: "AIzaSyCr8dYXfkQUzH1qYMoBgqjtWTqLgbydr_U"
// })(MapContainer);

// const LoadingContainer = (props) => <div>Fancy loading container!</div>;

// const GoogleMap = GoogleApiWrapper({
//   apiKey: "AIzaSyCr8dYXfkQUzH1qYMoBgqjtWTqLgbydr_U",
//   LoadingContainer: LoadingContainer,
// })(MapContainer);

export default MapContainer;

// export default GoogleApiWrapper({ apiKey: 'AIzaSyCr8dYXfkQUzH1qYMoBgqjtWTqLgbydr_U' })(MapContainer)